import { render, staticRenderFns } from "./ModalValue.vue?vue&type=template&id=6adcf31a&scoped=true&"
import script from "./ModalValue.vue?vue&type=script&lang=js&"
export * from "./ModalValue.vue?vue&type=script&lang=js&"
import style0 from "./ModalValue.vue?vue&type=style&index=0&id=6adcf31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adcf31a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6adcf31a')) {
      api.createRecord('6adcf31a', component.options)
    } else {
      api.reload('6adcf31a', component.options)
    }
    module.hot.accept("./ModalValue.vue?vue&type=template&id=6adcf31a&scoped=true&", function () {
      api.rerender('6adcf31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/tabs/components/ModalValue.vue"
export default component.exports